import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Check if this is an AbortError - if so, don't show error UI
    if (error?.name === 'AbortError' || error?.message?.includes('aborted')) {
      console.log('[ErrorBoundary] Suppressed AbortError');
      return { hasError: false, error: null };
    }
    
    // For other errors, update state
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Check if this is an AbortError
    if (error?.name === 'AbortError' || error?.message?.includes('aborted')) {
      console.log('[ErrorBoundary] Caught and suppressed AbortError');
      // Reset the error state
      this.setState({ hasError: false, error: null });
      return;
    }
    
    // Log other errors
    console.error('[ErrorBoundary] Caught error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div style={{ padding: '20px', textAlign: 'center' }}>
          <h1>Something went wrong.</h1>
          <p>{this.state.error?.message}</p>
          <button onClick={() => window.location.reload()}>
            Reload Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
